export default __webpack_public_path__ + "static/media/Ojo-cerrado.7ebb0837.svg";